module.exports = __webpack_public_path__ + "static/media/Overcast.a76142c2.svg";